// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sc-suggestions-row{text-align:center;background:inherit}.sc-suggestions-element{margin:3px;padding:5px 10px 5px 10px;border:1px solid;border-radius:15px;font-size:14px;background:inherit;cursor:pointer}", ""]);
// Exports
module.exports = exports;
